import { useEffect, useState } from "react";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import '../css/form.css'
import Mode from "../components/styles/Mode";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import { useDispatch } from "react-redux";

const DuplicateError = () => {

    const dispatch = useDispatch()

    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))


        const urlParams = new URLSearchParams(window.location.search)
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        setFirstName(first_name)
        setLastName(last_name)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="dq-page" style={{ background: 'white' }}>
                {(firstName && lastName) && <div className="margin-auto error-div" style={{ textAlign: 'center', padding: 20 }}>
                    <Spacebox padding="20px" />
                    <Flexbox alignItems="center" justifyContent="center">
                        <img src="/assets/color-logo.png" alt="Final debt relief" style={{ width: 200 }} />
                    </Flexbox>
                    <Spacebox padding="10px" />
                    <Flexbox justifyContent="space-between" alignItems="center">
                        <div>
                            <span>
                                Name: <b>{firstName} {lastName}</b>
                            </span>
                            <Spacebox padding="0px" />
                            <span>
                                Date: <b>{(new Date()).toString().substring(4, 16)}</b>
                            </span>
                        </div>
                    </Flexbox>
                    <Spacebox padding="20px" />
                    <div className="margin-auto" style={{ textAlign: 'center', maxWidth: 500 }}>
                        <span style={{ fontSize: 25, fontWeight: 600 }} className="trade-green">
                            We've Found a Duplicate Submission
                        </span>
                        <Spacebox padding="10px" />
                        <span>
                            It looks like you've already submitted your information with us. If you believe this is an error, our support team will be happy to help. Please reach out at <b><a className="text-place" href="mailto:support@finaldebtrelief.com">support@finaldebtrelief.com</a></b> so we can review and resolve this quickly.
                        </span>
                        <Spacebox padding="20px" />
                    </div>
                </div>}
            </div>
        </Mode>
    );
}

export default DuplicateError;